var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-nav-menu',_vm._l((_vm.menuItems),function(link){return _c('router-link',{key:link.destination,attrs:{"to":link.destination,"rel":link.rel},nativeOn:{"click":function($event){return _vm.setManualHistory([])}}},[_vm._v(" "+_vm._s(link.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }